import PosthogService from '~/services/posthog/PosthogService';
import { CandidateStatus } from '~/domain/PermanentJobs/enums/CandidateStatus';

// Event-specific interface (co-located)
export interface IPermCandidateListCandidateClickedPayload {
  postingId: string;
  professionalId: string;
  candidateStatus: CandidateStatus;
}

/**
 * Fires when user clicks on a candidate in the candidates list
 * Event: dental_portal:perm_candidate_list:candidate_clicked
 */
export function firePermCandidateListCandidateClicked(
  payload: IPermCandidateListCandidateClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_candidate_list:candidate_clicked', {
    posting_id: payload.postingId,
    professional_id: payload.professionalId,
    candidate_status: payload.candidateStatus,
  });
}